"use client";

import { useState } from "react";
import Link from "next/link";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import SidebarNav from "@/components/sidebar-nav";

export default function HeaderClient({
  children,
}: {
  children: React.ReactNode;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(true); // Changed to true for default open

  return (
    <>
      <header className="w-full flex justify-center border-b border-b-foreground/10 h-16">
        <div className="w-full max-w-7xl flex justify-between items-center p-3 px-5 text-sm">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="hover:bg-muted"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <Link href={"/"} className="text-xl font-semibold">
              On Air
            </Link>
          </div>
          {children}
        </div>
      </header>

      <SidebarNav isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </>
  );
}
